
import { combineReducers } from 'redux';

import datawin from './datawin';
import dataModelDefinition from './dataModelDefinition';
import document from './document';
import info from './info';

export function getDatawin(state) {
    return state.datawin;
}

export function getDataModelDefinition(state) {
    return state.dataModelDefinition;
}

export function getDocument(state) {
    return state.document;
}

export function getInfo(state) {
    return state.info;
}

export default combineReducers({
    datawin,
    dataModelDefinition,
    document,
    info
});
